import type { TEmailBuilderAutoSaveStatus } from "redux/reducers/emailBuilder/emailBuilder";

export type TEmailBuilderBackNavigationDecision =
  | { kind: "navigate" }
  | { kind: "flush-then-navigate" }
  | { kind: "ignore-duplicate" };

export type TEmailBuilderServerDraftGateDecision =
  | { kind: "proceed" }
  | { kind: "flush-then-proceed" }
  | { kind: "ignore-duplicate" };

export function emailBuilderHasPendingAutosave(
  autoSaveStatus: TEmailBuilderAutoSaveStatus,
): boolean {
  return autoSaveStatus === "unsaved-changes" || autoSaveStatus === "saving";
}

export function decideEmailBuilderBackNavigation(params: {
  autoSaveStatus: TEmailBuilderAutoSaveStatus;
  isFlushing: boolean;
  autoSaveConflict?: boolean;
}): TEmailBuilderBackNavigationDecision {
  if (params.autoSaveConflict) {
    return { kind: "ignore-duplicate" };
  }

  if (params.isFlushing) {
    return { kind: "ignore-duplicate" };
  }

  if (emailBuilderHasPendingAutosave(params.autoSaveStatus)) {
    return { kind: "flush-then-navigate" };
  }

  return { kind: "navigate" };
}

export function decideEmailBuilderServerDraftGate(params: {
  autoSaveStatus: TEmailBuilderAutoSaveStatus;
  isFlushing: boolean;
  autoSaveConflict?: boolean;
}): TEmailBuilderServerDraftGateDecision {
  if (params.autoSaveConflict) {
    return { kind: "ignore-duplicate" };
  }

  if (params.isFlushing) {
    return { kind: "ignore-duplicate" };
  }

  if (emailBuilderHasPendingAutosave(params.autoSaveStatus)) {
    return { kind: "flush-then-proceed" };
  }

  return { kind: "proceed" };
}
